/**
 *
 * InlineLoader
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Conditional } from '@cashfree-intl/coherent';

function InlineLoader({ loading, content }) {
  return (
    <>
      <Conditional if={loading}>
        <span className="text-lighter medium-text w-400 flex">
          Loading...
          <div className="inline-loader" />
        </span>
      </Conditional>
      <Conditional if={!loading}>
        {typeof content === 'function' ? content() : content}
      </Conditional>
    </>
  );
}

InlineLoader.propTypes = {
  loading: PropTypes.bool.isRequired,
  content: PropTypes.any,
};

export default memo(InlineLoader);
